module.exports = __webpack_public_path__ + "static/media/config.c3eb8d91.svg";